import { CMS_OnClickType } from '@/types'

interface ComponentType {
  __typename: string
  content: any
}

const findComponentByType = (
  component: string,
  array: ComponentType[] | any
) => {
  return Array.isArray(array)
    ? array.find((el) => el.__typename === component)?.content
    : array?.[component] || undefined
}

function handleOnClickModel(ctaData: CMS_OnClickType | undefined) {
  if (ctaData) {
    return function () {
      const { href, target, rel } = ctaData

      if (typeof window !== 'undefined') {
        if (target === '_blank') {
          const tempAnchor = document.createElement('a')
          tempAnchor.href = href
          tempAnchor.target = target
          tempAnchor.rel = rel || 'noopener noreferrer'
          document.body.appendChild(tempAnchor)
          tempAnchor.click()
          document.body.removeChild(tempAnchor)
        } else {
          window.location.href = href
        }
      }
    }
  }

  return undefined
}

export { findComponentByType, handleOnClickModel }
